module.exports = __webpack_public_path__ + "media/מיטה.7cb54679.mp3";